<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { AvatarRoot } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<{
    class?: HTMLAttributes['class'];
}>();
</script>

<template>
    <AvatarRoot
        data-slot="avatar"
        :class="
            cn(
                'bg-accent-0 relative flex size-8 shrink-0 overflow-hidden rounded-full border p-1',
                props.class
            )
        "
    >
        <slot />
    </AvatarRoot>
</template>
